import { Link } from "@tanstack/react-router";
import { cn } from "@/lib/utils";

type ReportProductLinkProps = {
  productId: string;
  productName: string;
  variantName: string;
  className?: string;
};

export function ReportProductLink({
  productId,
  productName,
  variantName,
  className,
}: ReportProductLinkProps) {
  return (
    <div className={className}>
      <Link
        to="/app/products/$id/stock"
        params={{ id: productId }}
        className="font-medium text-secondary hover:underline"
      >
        {productName}
      </Link>
      <div className="text-muted-foreground text-xs">{variantName}</div>
    </div>
  );
}

export function ReportStat({
  label,
  value,
  className,
  valueClassName,
}: {
  label: React.ReactNode;
  value: React.ReactNode;
  className?: string;
  valueClassName?: string;
}) {
  return (
    <div className={cn("flex flex-col gap-0.5", className)}>
      <dt className="text-muted-foreground text-xs">{label}</dt>
      <dd className={cn("font-medium tabular-nums", valueClassName)}>
        {value}
      </dd>
    </div>
  );
}

export function ReportMobileCard({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "rounded-xl border border-secondary/15 bg-background/60 p-3",
        className,
      )}
    >
      {children}
    </div>
  );
}
